declare var Card: any;
namespace AgerLMS.WebSite {

    export interface CartPaymentFormWidgetRequest {
        error:string
        paymentSucceed?:boolean;
    }

    @Serenity.Decorators.registerClass()
    export class CartPaymentFormWidget extends Serenity.Widget<CartPaymentFormWidgetRequest> {

        button : string = "#CartPaymentButton";
        formSelector : string = "#CartPaymentForm";
        binNumber : string;
        price: string;

        constructor(element: JQuery, opt: CartPaymentFormWidgetRequest) {
            super(element, opt);

            if (opt.error == "") opt.error = null
            if (opt.error != null) SweetAlert.swal_alert("HATA", opt.error);

            // if (opt.paymentSucceed) opt.paymentSucceed = null
            if (opt.paymentSucceed == true) SweetAlert.swal_success_then("Ödeme Başarılı", "Ödemeniz başarıyla gerçekleştirildi. Siparişinizin durumunu siparişlerim sayfasından takip edebilirsiniz.", () => {
                window.location.href = Q.resolveUrl("~/odeme-basarili");
            });

            var form = $(this.formSelector);
            // form.find("input[name='name']").val("DURSUN YILMAZ");
            // form.find("input[name='number']").val("4183 4217 6192 9719");
            // form.find("input[name='cvc']").val("612");
            // form.find("input[name='expiry']").val("12 / 28");

            // form.find("input[name='name']").val("RECEP TUNA");
            // form.find("input[name='number']").val("5188963000885931");
            // form.find("input[name='cvc']").val("316");
            // form.find("input[name='expiry']").val("12 / 27");

            this.bindValidate();
            this.bindCreditCardAnimation();
            this.bindCreditCardChange();
            this.bindPaymentTypeChange();
            this.bindBankTransferPaymentButton();

            var self = this;

            $(self.button).click(e => {
                e.preventDefault();

                if (!form.valid()) return;

                form.submit();
            });

            $(document).keypress(function(e){
                if (e.which == 13){
                    $(this.button).click();
                }
            });
        }

        private bindCreditCardAnimation() {
            var c = new Card({
                form: document.querySelector('.credit-card-form'),
                container: '.card-wrapper',
                placeholders: {
                    name: 'AD SOYAD',
                    number: '•••• •••• •••• ••••',
                    expiry: '••/••',
                    cvc: '•••'
                },
                messages: {
                    monthYear: 'ay/yıl',
                }
            });
        }

        private bindValidate() {
            var self = this;

            let r = {
                name: {
                    required: true
                },
                number: {
                    required: true,
                    maxlength: 19,
                    minlength: 19
                },
                expiry: {
                    required: true,
                    maxlength: 7,
                    minlength: 7
                },
                cvc: {
                    required: true,
                    maxlength: 3,
                    minlength: 3
                },
                agreementlink: {
                    required: true
                },
                BillingAddressId: {
                    required: true
                }
            };
            let m = {
                name: {
                    required: "* Kredi kartı sahibinin adını girin."
                },
                number: {
                    required: "* Kredi kart numarasını girin.",
                    maxlength:"* Kredi kart numarası 16 karakter olmalıdır.",
                    minlength:"* Kredi kart numarası 16 karakter olmalıdır."
                },
                expiry: {
                    required: "* Son kullanma tarihini girin.",
                    maxlength:"* Son kullanma tarihi düzgün girilmemiştir. (ay/yıl) şeklinde girilmelidir. (01/23) gibi.",
                    minlength:"* Son kullanma tarihi düzgün girilmemiştir. (ay/yıl) şeklinde girilmelidir. (01/23) gibi.",
                },
                cvc: {
                    required: "* Güvenlik kodunu girin.",
                    maxlength:"* Güvenlik kodu 3 karakter olmalıdır.",
                    minlength:"* Güvenlik kodu 3 karakter olmalıdır."
                },
                agreementlink: {
                    required: "* Mesafeli Satış Sözleşme maddelerini kabul etmelisiniz."
                },
                BillingAddressId: {
                    required: "* Lütfen fatura adresini seçiniz."
                }
            };

            //RT.recaptchaInclude(this.options.Recaptcha, $(self.button), r, m);

            $(this.formSelector).validate({
                errorClass: "is-invalid",
                rules: r,
                messages: m
            });
        }

        bindPaymentTypeChange() {
            var self = this;
            $("#bank-transfer-form-wrapper").hide();
            $('input[type=radio][name=payment-type]').change(function() {
                if (this.value == OrderPaymentTypes.CreditCard.toString())
                {
                    $("#credit-card-form-wrapper").show();
                    $("#bank-transfer-form-wrapper").hide();
                }
                else if (this.value == OrderPaymentTypes.BankTransfer.toString())
                {
                    $("#credit-card-form-wrapper").hide();
                    $("#bank-transfer-form-wrapper").show();
                }
            });
        }

        bindBankTransferPaymentButton() {
            var self = this;
            $("#bank-transfer-payment-button").click(e => {
                e.preventDefault();

                let billingAddressId = $("input[name='billing_addressId']").val();
                let shippingAddressId = $("input[name='shipping_addressId']").val();

                if (billingAddressId == null || billingAddressId == "")
                {
                    SweetAlert.swal_alert("HATA", "Fatura adresi seçmelisiniz.");
                    return;
                }

                if (shippingAddressId == null || shippingAddressId == "")
                {
                    SweetAlert.swal_alert("HATA", "Teslimat adresi seçmelisiniz.");
                    return;
                }

                LMS.PaymentService.BankTransferPayment({ BillingAddressId: Q.toId(billingAddressId), ShippingAddressId: Q.toId(shippingAddressId)  }, response => {
                    window.location.href = Q.resolveUrl("~/banka-transfer-talebi-basarili?orderId=" + response.EntityId);
                }, {
                    onError: (r) => {
                        SweetAlert.swal_alert("HATA", r.Error.Message);
                    }
                });
            });
        }

        bindCreditCardChange() {
            var self = this;
            var form = $(this.formSelector);
            var cardNumber = form.find("input[name='number']");

            let cardNumberChange = ()=> {
                var cardNumberValue = cardNumber.val();
                //kart numarası üzerindeki boşlukları kaldırıyoruz
                cardNumberValue = cardNumberValue.replace(/\s/g, '');

                if (cardNumberValue.length < 6) return;
                if (self.binNumber != cardNumberValue.substring(0, 6))
                    self.binNumber = cardNumberValue.substring(0, 6)

                LMS.PaymentService.RetrieveInstallmentInfo({ Entity : self.binNumber }, response => {
                    let r = JSON.parse(response.Entity) as InstallmentInfoResponse;
                    self.drawInstallmentTable(r);
                    $("#installments-table-wrapper").find("input[name='installment'][value=1]").attr('checked', 'checked');
                });
            };

            //kredi kartı textbox yazınca işlem yapacak
            cardNumber.on("keyup", cardNumberChange);
        }

        drawInstallmentTable(response: InstallmentInfoResponse) {
            var self = this;

            let installmentTableDiv = $("#installments-table-wrapper");
            installmentTableDiv.empty();

            if (!response.InstallmentDetails ||
                response.InstallmentDetails.length == 0 ||
                response.InstallmentDetails[0].InstallmentPrices.length == 0 ||
                response.InstallmentDetails[0].InstallmentPrices.length == 1) return;

            let table = $("<table class='table table-striped table-bordered table-hover table-checkable order-column' id='installments-table'>");
            let thead = $("<thead>");

            let trHead = $("<tr>");
            let thTakitSayisi = $("<th>").text("Taksit Sayısı");
            let thTaksitTutari = $("<th>").text("Taksit Tutarı");
            let thToplamTutar = $("<th>").text("Toplam Ödeme");

            trHead.append(thTakitSayisi);
            trHead.append(thTaksitTutari);
            trHead.append(thToplamTutar);
            thead.append(trHead);
            table.append(thead);

            let tbody = $("<tbody>").addClass("boxed-check-group boxed-check-success");
            response.InstallmentDetails[0].InstallmentPrices.forEach(element => {
                let trBody = $("<tr>");
                let tdTaksitSayisi = $("<td>").addClass("boxed-check-wrapper");
                let label = $("<label>").addClass("boxed-check");
                let input = $("<input>").addClass("boxed-check-input").attr("type", "radio").attr("name", "installment").attr("value", element.InstallmentNumber.toString());
                
                let text = element.InstallmentNumber.toString() + " Taksit";
                if (element.InstallmentNumber == 1) text = "Tek Çekim";
                let div = $("<div>").addClass("boxed-check-label").text(text);
                label.append(input);
                label.append(div);
                tdTaksitSayisi.append(label);
                
                let tdTaksitTutari = $("<td>").html(self.trPriceHtml(element.InstallmentPrice));
                let tdToplamTutar = $("<td>").html(self.trPriceHtml(element.TotalPrice.toString()));

                trBody.append(tdTaksitSayisi);
                trBody.append(tdTaksitTutari);
                trBody.append(tdToplamTutar);
                tbody.append(trBody);
            });
            table.append(tbody);

            installmentTableDiv.append(table);
        }

        trPriceHtml(price?: any): string {
            price = price || 0;
    
            if (price != null)
                return "<span class='tr-price'>₺</span> " + parseFloat(price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/\.(\d+)$/,',$1') 
        }
    }

    export interface InstallmentInfoResponse {
        Status: string;
        InstallmentDetails:InstallmentDetails[];
    }

    export interface InstallmentDetails {
        CardType: string;
        CardAssociation: string;
        CardFamilyName: string;
        BankName: string;
        InstallmentPrices:InstallmentPrices[];
    }

    export interface InstallmentPrices {
        InstallmentPrice:number;
        TotalPrice?:number;
        InstallmentNumber?:number;
    }
}